import * as React from 'react'
import css from './Toggle.module.scss'
import { LoadingSpinner } from '../LoadingSpinner'

interface ToggleProps {
	id?: string
	checked?: boolean
	isLoading?: boolean
	onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export const Toggle: React.FunctionComponent<ToggleProps> = ({ id, checked, onChange, isLoading }) => {
	return (
		<label htmlFor={id} className={css['toggle']}>
			{isLoading && (
				<div className={css.loadingSpinnerContainer}>
					<LoadingSpinner />
				</div>
			)}
			<input id={id} type="checkbox" checked={checked} onChange={onChange} aria-label="toggle" />
			<span className={css['toggle-slider']}></span>
		</label>
	)
}
